import { capitalize, compact, flattenDeep } from 'lodash'
import axios from 'axios'

export function scrollToTop() {
  document.querySelector('.js-content-main')?.scrollTo({ top: 0, behavior: 'smooth' })
}

export function preventDefault(fn) {
  return function (event) {
    event.preventDefault()
    fn.call(this, event)
  }
}

export function stopPropagation(fn) {
  return function (event) {
    event.stopPropagation()
    fn.call(this, event)
  }
}

export const isRelativeDate = (date) => {
  return /^\d+$/.test(date)
}

export const textColor = (hexcolor) => {
  if (!hexcolor) {
    return '#ffffff'
  }

  hexcolor = hexcolor.replace('#', '')
  let r, g, b

  if (hexcolor.length === 3) {
    r = hexcolor[0] + hexcolor[0]
    g = hexcolor[1] + hexcolor[1]
    b = hexcolor[2] + hexcolor[2]
  } else {
    r = hexcolor[0, 1]
    g = hexcolor[2, 3]
    b = hexcolor[4, 5]
  }

  r = parseInt(r, 16)
  g = parseInt(g, 16)
  b = parseInt(b, 16)

  let threshold = 128
  let delta = (r * 0.299) + (g * 0.587) + (b * 0.114)

  return ((255 - delta) < threshold) ? '#222' : '#fff'
}

export const clone = (obj) => _.cloneDeep(obj)

export const escapeHTML = (html) => {
  let textarea = document.createElement('textarea')
  textarea.textContent = html
  return textarea.innerHTML
}
export const unescapeHTML = (text) => {
  let textarea = document.createElement('textarea')
  textarea.innerHTML = text
  return textarea.textContent
}
export const stripHTML = (html) => {
  let div = document.createElement('div')
  div.innerHTML = html
  return div.textContent
}

export const escapeRegExp = (string) => {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

export const isAscii = (str) => {
  return /^[\x00-\x7F]*$/.test(str)
}

export const unique = (arr) => {
  let hash, i, l, result
  hash = {}
  result = []
  i = 0
  l = arr.length
  while (i < l) {
    if (!hash.hasOwnProperty(arr[i])) {
      hash[arr[i]] = true
      result.push(arr[i])
    }
    ++i
  }
  return result
}

export function transformErrors(errors) {
  if (errors?.response) {
    let msgs = [],
      data = errors.response.data
    for (let key in data) {
      for (const msg of data[key]) {
        msgs.push(`${capitalize(key)} ${msg}`)
      }
    }
    return msgs
  } else {
    return compact(flattenDeep([errors]))
  }
}

export const accountHasFeature = (feature) => {
  let meta = document.querySelector(`meta[name="has-${feature}"]`)
  try {
    return meta.attributes.content.value === 'true'
  } catch (e) {
    return false
  }
}

export const dumbPluralize = (count, singularWord) => {
  return App.utils.dumb_pluralize(count, singularWord)
}

export const checkKeywordAvailability = (keyword, keywordId) => {
  let kw = window.encodeURIComponent(keyword)

  if (kw.trim().length) {
    return axios.get(`/keywords/availability/${kw}/${keywordId || null}.json`)
      .catch(error => {
        console.log('Error in utils.checkKeywordAvailability: ', error)
      })
  } else {
    return new Promise((resolve) => {
      resolve({ data: {} })
    })
  }
}

export const LINK_REGEX = /((\bhttps?:\/\/)[^\r\n\s<,]+)|(\w+[\w.]*\.(com?|net|org|io|gl|ly)([^\r\n\s<,]+)*|([^\r\n\s<,]+)@([^\r\n\s<,]+))/gim

export const MAX_MSG_LENGTH_ASCII = 160

export const MAX_MSG_LENGTH_UTF16 = 70

export const UPDATE_PROFILE_LINK_HTML = '<div><a title="Update link" href="https://tsig.io/abc123" target="_blank">Edit your profile tsig.io/abc123</a></div>'
